var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg34(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V11.7969H24V0.5H0ZM22.5938 5.51562H15.4219V1.90625H22.5938V5.51562ZM1.40625 1.90625H14.0156V10.3906H1.40625V1.90625ZM15.4219 10.3906V6.92188H22.5938V10.3906H15.4219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.95314H10.5938V8.35939H4.875V6.95314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 18.1719H14.1094V20.2812H12.7031V15.3594C12.7031 14.9717 13.0185 14.6562 13.4062 14.6562C13.794 14.6562 14.1094 14.9717 14.1094 15.3594H15.5156C15.5156 14.1963 14.5694 13.25 13.4062 13.25C12.2431 13.25 11.2969 14.1963 11.2969 15.3594V20.2812H9.89062V18.1719H8.48438V20.2812H0V24.5H24V20.2812H15.5156V18.1719ZM22.5938 23.0938H1.40625V21.6875H22.5938V23.0938Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg34);
export default __webpack_public_path__ + "static/media/34.da9b90cd57dcf6f25ae19f0aef757908.svg";
export { ForwardRef as ReactComponent };